import React from 'react';
import Header from './Header';
import HeroSection from './HeroSection';
import AboutSection from './AboutSection'; // Importa el nuevo módulo
import BenefitsSection from './BenefitsSection';
import GamesSection from './GamesSection';
import HowItWorksSection from './HowItWorksSection';
import TestimonialsSection from './TestimonialsSection';
import PromotionsSection from './PromotionsSection';
import TrustSection from './TrustSection';
import HelpSection from './HelpSection';
import Footer from './Footer';

const LandingIndex = () => {
  return (
    <div>
      <section id='home'>
        <Header />
      </section>
      <HeroSection />
      <section id='about'>
        <AboutSection />
      </section>
      <BenefitsSection />
      <section id='games'>
        <GamesSection />
      </section>
      <section id='how-it-works'>
        <HowItWorksSection />
      </section>
      <TestimonialsSection />
      <section id='promotions'>
        <PromotionsSection />
      </section>
      <TrustSection />
      <section id='help'>
        <HelpSection />
      </section>
      <Footer />
    </div>
  );
};

export default LandingIndex;
